import React from 'react';
import './index.scss';

type Props = {
  color: string;
  title: string;
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

const IconButton: React.FC<Props> = ({ className, color, title, children, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    className={`filter-button ${className || ''}`}
    style={{ background: color }}
  >
    <p style={{ marginRight: 12 }}>{title}</p>
    {children}
  </button>
);

export default IconButton;
